import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getDocument } from "../../services/user/UserServices";
import FilePreview from "../../common/FilePreview";
import DefaultImprint from "./defaultImprint";
import { Circles } from "react-loader-spinner";
import { Box } from "@mui/material";
import "./imprint.scss";
const Imprint = () => {
  const { t } = useTranslation();
  const [fileData, setFileData] = useState("");
  const [loader, setLoader] = useState(true);
  const auth = localStorage.getItem("auth");
  const uploadedFiles = localStorage.getItem("uploadedFiles");

  const navigateToImprintUrl = (url) => {
    window.location.replace(url);
  };
  const handleViewFile = async () => {
    if (uploadedFiles && uploadedFiles != "null") {
      const { imprintFile, imprintUrl } = JSON.parse(uploadedFiles);
      if (!imprintUrl && imprintUrl != "null") {
        if (imprintFile) {
          let result = await getDocument(imprintFile.url);
          if (result.success) {
            setFileData(result?.payLoad);
          }
        }
      } else {
        navigateToImprintUrl(imprintUrl);
      }
    } else {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (auth) handleViewFile();
  }, [auth]);
  return (
    <div>
      {auth ? (
        fileData ? (
          <FilePreview data={fileData} />
        ) : loader ? (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <DefaultImprint />
        )
      ) : (
        <DefaultImprint />
      )}
    </div>
  );
};

export default Imprint;
